import "./SchemeView.html";
import "./SchemeView.scss";

import "../../TimeRangeResult/TimeRangeResultComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import SchemeViewComponentController from "./SchemeViewComponentController";

export default class SchemeViewComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            colorTheme: "@",
            dayTypes: "<",
            initialDate: "<",
            lowResolutionMode: "<",
            schedule: "<",
            timeZone: "<",
        };
        this.controller = SchemeViewComponentController;
        this.templateUrl = "/App/Components/Forms/ResultSchedule/SchemeView/SchemeView.html";
    }
}

module("mmManagePortal").component("irSchemeView", new SchemeViewComponent());
